// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"156":"modals","745":"symptom-map","911":"pop-quiz","928":"content-tabs"}[chunkId] + ".js";
};